export const HOLDING_ENTITY_TYPES = {
    'Individual': {
        title: 'Individual',
    },
    'LLC': {
        title: 'LLC',
    },
    'Corporation': {
        title: 'Corporation',
    },
    'Trust': {
        title: 'Trust',
    },
    'Foundation': {
        title: 'Foundation',
    },
    'Other': {
        title: 'Other',
    }
};

export const HOLDING_ENTITY_NAME_MAX_LENGTH = 40;

export const HOLDING_ENTITY_INDIVIDUAL_TYPES = {
    'Primary': {
        title: 'Primary',
    },
    'Spouse': {
        title: 'Spouse',
    },
    'Sibling': {
        title: 'Sibling',
    },
    'Child': {
        title: 'Child',
    },
    'Parent': {
        title: 'Parent',
    },
    'Other': {
        title: 'Other',
    }
};